<template>
  <div>
    <Modal @closeModal="$emit('closeTriggered')">
      <!-- MODAL TITLE -->
      <div slot="modal-title">
        <span class="font-weight-bold">CONNECT TO SCHOOL</span>
      </div>
      <!-- MODAL BODY -->
      <div slot="modal-body">
        <div class="alert-comp">
          <AuthAlertCard
            v-if="show_alert"
            :alert_type="alert_type"
            :alert_msg="alert_msg"
          ></AuthAlertCard>
        </div>

        <div
          class="user-section-info mb-4 d-flex justify-content-start align-items-center nowrap"
        >
          <!-- AVATAR -->
          <div class="avatar avatar_lg brand_inverse_light_bg mr-3">
            <img
              v-lazy="childDetail.image"
              :alt="childDetail.full_name"
              class="avatar-img"
              v-if="childDetail.image"
            />
            <div
              class="avatar-text white-text font-weight-bold font-20"
              :class="setAvatarBg"
              v-else
            >
              {{ getInitial }}
            </div>
          </div>

          <!-- USER INFO -->
          <div class="user-info" v-if="childDetail.full_name">
            <div class="name font-weight-bold brand_navy text-capitalize">
              {{ childDetail.full_name }}
            </div>
            <div class="code border_grey_dark text-uppercase">
              {{ childDetail.code }}
            </div>
          </div>
        </div>

        <SetupForm
          :show_invite="false"
          @toggle-invite-form="toggleSchoolInvite"
          @find-school="toggleFindSchoolModal"
          @classCodeSubmitted="verifyClassCode($event)"
          :school_name="school_name"
          :class_name="class_name"
        ></SetupForm>

        <div class="row mt-4">
          <div class="col-12 d-flex justify-content-center align-items-center">
            <button
              class="btn btn-md btn-secondary"
              ref="doneBtn"
              :disabled="lock_done_btn"
              @click="joinClass"
            >
              Done
            </button>
          </div>
        </div>
      </div>
    </Modal>

    <InviteSchoolModal
      v-if="invite_school"
      @close-triggered="toggleSchoolInvite"
    ></InviteSchoolModal>
    <FindSchoolModal
      v-if="find_school"
      @toggle-invite-form="toggleSchoolInvite"
      @close-triggered="toggleFindSchoolModal"
    ></FindSchoolModal>
    <SchoolDetailsUpdatedModal
      v-if="school_details_updated"
      :student_id="getAuthUser.id"
      @toggle-school-details-updated="toggleSchoolDetailsUpdated"
      @close-triggered="toggleSchoolDetailsUpdated"
    ></SchoolDetailsUpdatedModal>
    <!-- MODAL -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { colors, random, shuffle, setInitial } from "@/scripts/utilities";
import Modal from "@/components/globalComps/Modal";
import SetupForm from "@/components/teachersComps/onboarding/SetupForm";
import { setTimeout } from "timers";

export default {
  name: "AddChildClassModal",

  components: {
    Modal,
    SetupForm,
    AuthAlertCard: () =>
      import(
        /* webpackChunkName: "AuthAlertCard" */ "@/components/globalComps/AuthComps/AuthAlertCard.vue"
      ),
    InviteSchoolModal: () =>
      import(
        /* webpackChunkName: "FindClassmodal" */ "@/components/modalComps/teacherModals/InviteSchoolModal"
      ),
    FindSchoolModal: () =>
      import(
        /* webpackChunkName: "FindClassmodal" */ "@/components/modalComps/teacherModals/FindSchoolModal"
      ),
    SchoolDetailsUpdatedModal: () =>
      import(
        /* webpackChunkName: "FindClassmodal" */ "@/components/modalComps/studentModals/SchoolDetailUpdated"
      ),
  },

  props: {
    childDetail: {
      type: Object,
      default() {
        return {};
      },
    },
    token: {
      type: String,
      default: "",
    },
  },

  computed: {
    ...mapGetters(["getAuthUser"]),

    setAvatarBg() {
      let shuffled = shuffle(colors);
      return shuffled[random(15, 0)];
    },

    getInitial() {
      return setInitial(this.childDetail.full_name);
    },

    getJoinClassPayload() {
      return {
        code: this.class_code,
        token: this.token,
      };
    },
  },

  data() {
    return {
      school_details_updated: false,
      find_class: false,
      find_school: false,
      class: null,
      school_name: null,
      class_name: null,
      invite_school: false,
      class_code: null,

      show_alert: false,
      alert_type: null, //SET TO EITHER SUCCESS OR ERROR
      alert_msg: null,

      lock_done_btn: true,
    };
  },

  methods: {
    ...mapActions(["verifyStudentClassCode", "addStudentToClass"]),

    toggleFindSchoolModal() {
      this.find_school = !this.find_school;
      if (this.find_school) {
        this.invite_school = false;
      }
    },

    toggleSchoolInvite() {
      this.invite_school = !this.invite_school;
      if (this.invite_school) {
        this.find_school = false;
      }
    },
    toggleSchoolDetailsUpdated() {
      console.log("hello");
      this.school_details_updated = !this.school_details_updated;
      this.$emit("closeTriggered");
      location.reload();
    },

    verifyClassCode(class_code) {
      this.class_code = class_code;

      this.verifyStudentClassCode(class_code)
        .then((response) => {
          // HANDLE 200 RESPONSE
          if (response.code === 200) {
            this.$refs.doneBtn.classList.remove("btn-secondary");
            this.$refs.doneBtn.classList.add("btn-accent");
            this.lock_done_btn = false;

            this.show_alert = true;
            this.alert_type = "success";
            this.alert_msg = "Class code verified!";

            this.school_name = response.data.school_name;
            this.class_name = response.data.class_name;

            setTimeout(() => {
              this.show_alert = false;
            }, 3000);
          }

          //HANDLE 406 RESPONSE
          else if (response.code === 406) {
            this.show_alert = true;
            this.alert_type = "error";
            this.alert_msg = "Class was not found!";

            this.school_name = null;
            this.class_name = null;

            setTimeout(() => {
              this.show_alert = false;
            }, 3000);
          }

          //   HANDLE ANY OTHER RESPONSE
          else {
            this.show_alert = true;
            this.alert_type = "error";
            this.alert_msg = "An error occured verifying class code!";

            this.school_name = null;
            this.class_name = null;

            setTimeout(() => {
              this.show_alert = false;
            }, 3000);
          }
        })
        .catch((err) => console.log(err));
    },

    joinClass() {
      this.$refs.doneBtn.disabled = true;
      this.$refs.doneBtn.innerHTML =
        '<div class="icon-dotted-roller font-17 mr-2 animate"></div>Please wait...';

      this.addStudentToClass(this.getJoinClassPayload)
        .then((response) => {
          if (response.code === 200) {
            this.$bus.$emit('updateTodo');
            this.show_alert = true;
            this.alert_type = "success";
            this.alert_msg = "Successfully joined class!";
            this.$refs.doneBtn.disabled = false;
            this.$refs.doneBtn.innerHTML = "Done";
            this.$emit("updateSchool");

            // this.school_details_updated = true;
            setTimeout(() => {
              this.show_alert = false;
              this.$emit("closeTriggered");
            }, 1000);
          } else {
            setTimeout(() => {
              this.show_alert = true;
              this.alert_type = "error";
              this.alert_msg = response.message;

              this.$refs.doneBtn.disabled = false;
              this.$refs.doneBtn.innerHTML = "Done";
            }, 2000);
          }
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>

<style lang="scss" scoped>
.alert-comp {
  position: relative;
  top: -40px;
  margin-bottom: -15px;
  transition: all 0.4s ease-in-out;
}

.user-section-info {
  .user-info {
    transition: all 0.4s ease-in-out;
    .name {
      font-size: 18px;
      line-height: 25px;
      margin-bottom: 4px;
    }
    .code {
      font-size: 14px;
      line-height: 19px;
    }
  }
}
</style>
